// 🚨 **TODO.md F-188. `confirmDirtyNav()` with NO argument shows the dialog and then does NOTHING on
// Continue, and FIVE call sites did exactly that.** Owner report, 2026-10-31: on the quality-control tab,
// picking another control from the dropdown with unsaved changes asked the question correctly — and
// Continue only left the select on the new value, never loading that control.
//
// 🔑 **The mechanism**: `window.confirmDirtyNav(callback)` stores the callback in `navTarget`, and
// `#modal-dirty-continue` runs `if (navTarget) { navTarget() }`. Called bare, `navTarget` is `undefined`,
// so Continue closes the modal and the user is left looking at a page that did not change.
//
// ⚠️ **This exists so the callback cannot be forgotten.** The correct form —
// `confirmDirtyNav(function () { dirty = false; go() })` — was written out at two of the seven sites and
// omitted at five, which is the shape `CLAUDE.md` calls MANDATORY to avoid: a detail every caller must
// remember. `spec/config/dirty_nav_guard_spec.rb` refuses a bare call.
//
// 📌 `dirty = false` BEFORE the action, not after: `offcanvasRight.hide()` and `$.getScript` both lead to
// handlers that read the flag, and the one correct pre-existing caller
// (`packs/application.js`'s `hide.bs.offcanvas`) clears it first for that reason.
export default function withDirtyGuard(action) {
  if (!dirty) {
    action()
    return
  }

  confirmDirtyNav(function () {
    dirty = false
    action()
  })
}
